<template>
  <v-card class="pa-4 elevation-1">
    <div class="d-flex align-center justify-space-between flex-wrap">
      <v-card-title class="text-subtitle-1 font-weight-bold pa-0">
        {{ $t('studentSatisfaction.breakdown_title') }}
      </v-card-title>
      <div class="d-flex align-center">
        <vue-json-to-csv
          :json-data="exportRows"
          :labels="exportLabels"
          :csv-title="exportFilename"
          separator=";"
        >
          <v-btn text small color="deep-purple lighten-1" class="mr-2" :disabled="!rows.length">
            <v-icon left small>mdi-download</v-icon>
            {{ $t('surveys.export.button') }}
          </v-btn>
        </vue-json-to-csv>
        <v-btn-toggle v-model="dimension" mandatory dense color="deep-purple lighten-1">
          <v-btn value="grade" small>{{ $t('studentSatisfaction.by_grade') }}</v-btn>
          <v-btn value="school" small>{{ $t('studentSatisfaction.by_school') }}</v-btn>
          <v-btn value="country" small>{{ $t('studentSatisfaction.by_country') }}</v-btn>
        </v-btn-toggle>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="rows"
      :items-per-page="10"
      class="elevation-0 mt-3"
    >
      <template v-slot:item.topTwoBox="{ item }">
        {{ formatPct(item.topTwoBox) }}
      </template>
      <template v-slot:item.averageScore="{ item }">
        {{ formatScore(item.averageScore) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv';

export default {
  name: 'SatisfactionBreakdownTable',
  components: { VueJsonToCsv },
  props: {
    rows: { type: Array, default: () => [] },
    campaignName: { type: String, default: '' },
  },
  data() {
    return {
      dimension: 'grade',
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('studentSatisfaction.col_segment'), value: 'label', align: 'start' },
        { text: this.$t('studentSatisfaction.col_responses'), value: 'n', align: 'center' },
        {
          text: this.$t('studentSatisfaction.col_top_two_box'),
          value: 'topTwoBox',
          align: 'center',
        },
        {
          text: this.$t('studentSatisfaction.col_average'),
          value: 'averageScore',
          align: 'center',
        },
      ];
    },
    exportRows() {
      return this.rows.map((row) => ({
        label: row.label,
        n: row.n,
        topTwoBox: this.formatPct(row.topTwoBox),
        averageScore: this.formatScore(row.averageScore),
      }));
    },
    exportLabels() {
      return {
        label: { title: this.$t('studentSatisfaction.col_segment') },
        n: { title: this.$t('studentSatisfaction.col_responses') },
        topTwoBox: { title: this.$t('studentSatisfaction.col_top_two_box') },
        averageScore: { title: this.$t('studentSatisfaction.col_average') },
      };
    },
    exportFilename() {
      return `breakdown_${this.dimension}_${this.campaignName}_${new Date().toISOString().slice(0, 10)}`;
    },
  },
  watch: {
    dimension(value) {
      this.$emit('dimension-change', value);
    },
  },
  methods: {
    formatPct(value) {
      return `${Math.round(value || 0)}%`;
    },
    formatScore(value) {
      return Number(value || 0).toFixed(1);
    },
  },
};
</script>
